import React from "react";
import { useAuthStore } from "@/stores/auth/store";
import SidebarExample from "./sidebar";
import LandingPage from "./LandingPage";

/**
 * Renders SidebarExample if authenticated, otherwise LandingPage.
 * Used as the element for the "/" route to ensure reactivity.
 */
const HomeOrLanding: React.FC = () => {
  const {user} = useAuthStore();
  return user ? <SidebarExample /> : <LandingPage />;
};

export default HomeOrLanding;
